import type { PropsWithChildren, ReactElement, RefObject } from 'react';
import {
  type EmbeddedPaymentElementConfiguration,
  type IntentConfiguration,
} from '@stripe/stripe-react-native';

export type StripePaymentProviderProps = {
  children: ReactElement | ReactElement[];
};

export type StripeElementsProviderProps = {
  children: ReactElement | ReactElement[];
  amount: number;
  sessionId?: string;
  disablePolling?: boolean;
};

export type StripePaymentElementProps = {
  children: PropsWithChildren['children'];
  embeddedPaymentElementView?: ReactElement | null;
  show: boolean;
};

export type UseStripePaymentProps = {
  isPaymentStatePollingEnabled: boolean;
  total: number;
  paymentMethods: readonly PaymentMethod[];
  stripeIntentConfigRef: RefObject<IntentConfiguration | null>;
  stripeElementConfigRef: RefObject<EmbeddedPaymentElementConfiguration | null>;
};

export type PaymentMethod = {
  id: string;
  description: string | null;
  nickname: string | null;
  cardType: PaymentMethodType;
  isDefault: boolean;
};

export enum PaymentMethodType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Visa = 'VISA',
  Unsupported = 'UNSUPPORTED',
}
